// extracted by mini-css-extract-plugin
export default {"textGold":"styles_text-gold__aLeTV","textSilver":"styles_text-silver__5C9YR","textBronze":"styles_text-bronze__p2C9w"};